import { CardProps } from '@/components/card/types';
import React from 'react';
import { cardVariantMap } from './const';
import { renameDomProps } from '@/utils/sanitizeDomProps';

const Card: React.FC<CardProps> = (props) => {
  const CardComponent = cardVariantMap[props.variant];
  const renamedProps = renameDomProps(props);
  return CardComponent ? (
    <CardComponent data-component-id="C023" {...renamedProps} />
  ) : null;
};

export default Card;
